import { useValidatePhoneNumber } from './useValidatePhoneNumber'

import type { Texts } from '../useTexts'

type ValidatePhoneNumber = ReturnType<typeof useValidatePhoneNumber>

export const createValidatePhoneNumber = async (
  texts: Texts,
  phoneNumber: string,
  validatePhoneNumber: ValidatePhoneNumber,
) => {
  const phoneNumberRequiredError = {
    id: 'phoneNumberRequiredError',
    message: texts.phoneRequired,
    field: 'phoneNumber',
    priority: 10,
  }

  const phoneNumberValidError = {
    id: 'phoneNumberValidError',
    message: texts.phoneInvalid,
    field: 'phoneNumber',
    priority: 10,
  }

  const requiredError = phoneNumber.trim().length === 0
  const valid = requiredError ? true : await validatePhoneNumber(phoneNumber)

  return {
    [phoneNumberRequiredError.id]: requiredError ? phoneNumberRequiredError : undefined,
    [phoneNumberValidError.id]: !valid ? phoneNumberValidError : undefined,
  }
}
